import {NgModule}  from '@angular/core';
import {LoginComponent} from '../AppScreens/login/login.component';
import {TokenGuard} from '../Interfaces/TokenGuard';
import {MenusComponent} from '../AppScreens/menus/menus.component';
import {ForgotPasswordComponent} from '../AppScreens/forgot-password/forgot-password.component';
import {NewUserComponent} from '../AppScreens/new-user/new-user.component';
import {ChartsComponent} from '../AppScreens/charts/charts.component';
import {ImportContainersComponent} from '../AppScreens/import-containers/import-containers.component';
import {GateActivityComponent} from '../AppScreens/gate-activity/gate-activity.component';
import {UtcsInquiryComponent} from '../AppScreens/utcs-inquiry/utcs-inquiry.component';
import {DetentionClaimInquiryComponent} from '../AppScreens/detention-claim-inquiry/detention-claim-inquiry.component';
import {RpmInspectionsComponent} from '../AppScreens/rpm-inspections/rpm-inspections.component';
import {BookingInquiryComponent} from '../AppScreens/booking-inquiry/booking-inquiry.component';
import {EnterPasscodeComponent} from '../AppScreens/enter-passcode/enter-passcode.component';
import {PeelOffPileComponent} from '../AppScreens/peel-off-pile/peel-off-pile.component';
import {EquipmentInquiryComponent} from '../AppScreens/equipment-inquiry/equipment-inquiry.component';
import {SealinkInquiryComponent} from '../AppScreens/sealink-inquiry/sealink-inquiry.component';
import {ImportExportChargesComponent} from '../AppScreens/import-export-charges/import-export-charges.component';
import {ChargesCalculatorComponent} from '../AppScreens/charges-calculator/charges-calculator.component';
import {NotificationsComponent} from '../AppScreens/notifications/notifications.component';
import {ApiSubscriptionComponent} from '../AppScreens/api-subscription/api-subscription.component';
import {AccountProfileComponent} from '../AppScreens/account-profile/account-profile.component';
import {SubUsersComponent} from '../AppScreens/sub-users/sub-users.component';
import {ReportsComponent} from '../AppScreens/reports/reports.component';
import {ContactInfoComponent} from '../AppScreens/contact-info/contact-info.component';
import {VesselScheduleComponent} from '../AppScreens/vessel-schedule/vessel-schedule.component';
import {EmptyReceivingComponent} from '../AppScreens/empty-receiving/empty-receiving.component';
import {UnderMaintComponent} from '../AppScreens/under-maint/under-maint.component';
import {DriverHomepageComponent} from '../AppScreens/driver-homepage/driver-homepage.component';
import {EmailReportsComponent} from '../AppScreens/email-reports/email-reports.component';
import {RouterModule, Routes} from '@angular/router';






const routes: Routes = [
  { path : '', component : LoginComponent},
  { path: 'login', component: LoginComponent, canActivate: [TokenGuard] },
  { path: 'menus', component: MenusComponent, canActivate: [TokenGuard] },
  { path: 'forgot', component: ForgotPasswordComponent },
  { path: 'newuser', component: NewUserComponent},
  { path: 'charts', component: ChartsComponent, canActivate: [TokenGuard] },
  { path: 'gateActivity', component: GateActivityComponent, canActivate: [TokenGuard] },
  { path: 'importContainers', component: ImportContainersComponent, canActivate: [TokenGuard] },
  { path: 'utcsInquiry', component: UtcsInquiryComponent, canActivate: [TokenGuard] },
  { path: 'detentionClaims', component: DetentionClaimInquiryComponent, canActivate: [TokenGuard] },
  { path: 'rpm', component: RpmInspectionsComponent, canActivate: [TokenGuard] },
  { path: 'bookingInquiry', component: BookingInquiryComponent, canActivate: [TokenGuard] },
  { path: 'confirm', component: EnterPasscodeComponent},
  { path: 'peelPiles', component: PeelOffPileComponent, canActivate: [TokenGuard] },
  { path: 'sealinks', component: SealinkInquiryComponent, canActivate: [TokenGuard] },
  { path: 'importCharges', component: ImportExportChargesComponent, canActivate: [TokenGuard] },
  { path: 'equipInq', component: EquipmentInquiryComponent, canActivate: [TokenGuard] },
  { path: 'chargesCalc', component: ChargesCalculatorComponent, canActivate: [TokenGuard] },
  { path: 'notifications', component: NotificationsComponent, canActivate: [TokenGuard] },
  { path: 'apis', component: ApiSubscriptionComponent, canActivate: [TokenGuard] },
  { path: 'reports', component: ReportsComponent, canActivate: [TokenGuard] },
  { path: 'subUsers', component: SubUsersComponent, canActivate: [TokenGuard] },
  { path: 'profile', component: AccountProfileComponent, canActivate: [TokenGuard] },
  { path: 'driverhome', component: DriverHomepageComponent},
  { path: 'contact', component: ContactInfoComponent, canActivate: [TokenGuard] },
  { path: 'vesselRec', component: VesselScheduleComponent, canActivate: [TokenGuard] },
  { path: 'emptyRec', component: EmptyReceivingComponent, canActivate: [TokenGuard] },
  { path: 'emailreports', component: EmailReportsComponent, canActivate: [TokenGuard] },
];

@NgModule({

  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [
    RouterModule
  ],
  providers: [],
  declarations: []
})

export class AppRoutingModule { }
